import type { ActivityEntry, ActivitySubject } from './types';

/** Entries a snapshot carries at most; the timeline it becomes trims further by bytes. */
export const MAX_SNAPSHOT_ENTRIES = 50;

/**
 * Whether an entry belongs in the snapshot of a failure: the failing widget's own entries,
 * and the host-level ones around them (the route, clicks on the shell's chrome). Another
 * widget's entries do not, nor another instance's of the same widget when both are known.
 */
export function concerns(entry: ActivityEntry, subject: ActivitySubject): boolean {
  if (entry.scope === undefined) {
    return true;
  }
  if (entry.scope !== subject.scope) {
    return false;
  }
  return (
    entry.instanceId === undefined ||
    subject.instanceId === undefined ||
    entry.instanceId === subject.instanceId
  );
}

/** The newest entries that concern the failing widget, oldest first. */
export function selectActivity(
  entries: readonly ActivityEntry[],
  subject: ActivitySubject,
  limit: number = MAX_SNAPSHOT_ENTRIES
): ActivityEntry[] {
  const relevant = entries.filter((entry) => concerns(entry, subject));
  return relevant.slice(Math.max(0, relevant.length - limit));
}
